<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="bcorp.icon" class="mr-1"></i>
                        <span>{{ bcorp.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body class="mt-3 mx-4">
                <p> B Corp Certification demonstrates a company's entire social and environmental impact.</p>


                <p>B Corp Certification is a designation that a business is meeting high standards of verified performance,
                    accountability, and transparency on factors from employee benefits and charitable giving to supply chain
                    practices and input materials. In order to achieve certification, a company must: </p>
                <ul>
                    <li> Demonstrate high social and environmental performance by achieving a B Impact Assessment score of
                        80 or
                        above and passing our risk review. Multinational corporations must also meet baseline requirement
                        standards.</li>
                    <li> Make a legal commitment by changing their corporate governance structure to be accountable to all
                        stakeholders, not just shareholders, and achieve benefit corporation status if available in their
                        jurisdiction.</li>
                    <li> Exhibit transparency by allowing information about their performance measured against B Lab's
                        standards to
                        be publicly available on their B Corp profile on B Lab's website.</li>
                </ul>
                <p>As leaders in the movement for economic systems change, B Corps reap remarkable benefits. They build
                    trust with consumers, communities, and suppliers; attract and retain employees; and draw mission-aligned
                    investors. As they are required to undergo the verification process every three years in order to
                    recertify, B Corps are by definition also focused on continuous improvement, leading to their long-term
                    resiliency. </p>
                <p>B Corp Certification is holistic, not exclusively focused on a single social or environmental issue. And
                    the process to achieve and maintain certification is rigorous and requires engaging teams and
                    departments across your company. Taking company size and profile into account, verification involves
                    documentation of your company's business model and information about your operations, structure, and
                    various work processes, as well as review of potential public complaints and possible site visits.
                    Recertification confirms these standards continue to be met on an ongoing basis. </p>

                <p> <b-aspect :aspect="aspect">
                    <div> <b-embed type="iframe" aspect="4by3" src="https://player.vimeo.com/video/651234509" allowfullscreen></b-embed></div>
                    </b-aspect></p>
                <p>For further information keep reading on <a href="https://www.bcorporation.net" target="_blank"
                        class="pr-4"> www.bcorporation.net.</a> </p>

            </b-card-body>


        </b-card>
    </div>
</template>
    
    
<script>
import gql from "graphql-tag";

export default {
    name: "BCorp",
    components: {},

    data() {
        return {
            aspect: '16:9',
            aspects: [
                { text: '4:3 (SD)', value: '4:3' },
                { text: '1:1 (Square)', value: '1:1' },
                { text: '16:9 (HD)', value: '16:9' },
                { text: '1.85:1 (Widescreen)', value: '1.85:1' },
                { text: '2:1 (Univisium/Superscope)', value: '2:1' },
                { text: '21:9 (Anamorphic)', value: '21:9' },
                { text: '1.43:1 (IMAX)', value: '1.43:1' },
                { text: '3:2 (35mm Film)', value: '3:2' },
                { text: '3:1 (APS-P)', value: '3:1' },
                { text: '4/3 (Same as 4:3)', value: 4 / 3 },
                { text: '16/9 (Same as 16:9)', value: 16 / 9 },
                { text: '3 (Same as 3:1)', value: 3 },
                { text: '2 (Same as 2:1)', value: 2 },
                { text: '1.85 (Same as 1.85:1)', value: 1.85 },
                { text: '1.5', value: 1.5 },
                { text: '1 (Same as 1:1)', value: 1 }
            ],
            bcorp: {
                title: "B Corp",
                icon: "fa fa-envira",
                debounce: 500,
                busy: false,
            },
        };
    },

};
</script>
    
<style></style>